import type { OperatorSummary } from "./accessApi";
import { isAccessKey, type AccessTranslate } from "./useAccessT";

/** Russian label of a permission id; unknown ids show the raw value. */
export function permissionLabel(t: AccessTranslate, id: string): string {
  const key = `admin.access.permission.${id}`;
  return isAccessKey(key) ? t(key) : id;
}

/** Russian name of a seeded role; others fall back to the server name. */
export function roleLabel(
  t: AccessTranslate,
  id: string,
  fallback: string,
): string {
  const key = `admin.access.role.name.${id}`;
  return isAccessKey(key) ? t(key) : fallback;
}

export function operatorName(
  operator: Pick<OperatorSummary, "display_name" | "subject_hint">,
): string {
  return operator.display_name ?? operator.subject_hint;
}

/** Message for a server refusal code; unknown codes use the generic text. */
export function errorMessage(t: AccessTranslate, code: string): string {
  const key = `admin.access.error.${code}`;
  return isAccessKey(key) ? t(key) : t("admin.access.error.generic");
}

/** Groups permission ids by their first segment, both levels sorted. */
export function groupPermissions(ids: readonly string[]): [string, string[]][] {
  const groups = new Map<string, string[]>();
  for (const id of [...ids].sort()) {
    const prefix = id.split(".")[0] ?? id;
    groups.set(prefix, [...(groups.get(prefix) ?? []), id]);
  }
  return [...groups.entries()];
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string): boolean {
  return UUID.test(value.trim());
}
